/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var random = function random() {
  return Date.now ? "".concat(Date.now()).concat(Math.random()) : "".concat(new Date().getTime()) + Math.random();
};
var _default = function _default(col) {
  col.id = col.id == null ? col.name || random() : col.id;
  return col;
};
exports.default = _default;